var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotwear10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4221 82.4085C41.9879 81.9743 42.2164 77.2702 42.1898 76.2685C42.0031 69.8466 41.8393 63.2952 41.7822 56.8694C41.6984 47.2061 41.7289 37.5123 41.9765 27.8604C43.6524 27.3767 44.7722 27.3234 46.0025 25.9636C46.1854 25.7617 46.2082 25.3351 46.3606 25.2323C46.6996 24.9923 47.0728 25.5293 46.89 24.2076L51.6093 24.4895L51.7921 24.8933C51.7083 27.8985 51.9026 30.919 51.7998 33.9205C51.3313 47.7737 50.9656 61.6192 50.6076 75.4762C50.5809 76.5275 50.8056 81.9819 50.4247 82.3552C49.3049 83.4483 43.9609 82.8694 42.4221 82.4009V82.4085Z",
    fill: "#AE2100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1287 25.1637C57.1972 25.2399 57.5134 25.1637 57.6086 25.2475C57.8714 25.4837 58.0162 26.0284 58.3666 26.3674C59.2769 27.2549 60.7624 27.5558 61.9737 27.7614C62.1336 31.1248 62.2213 34.4652 62.1984 37.8514C62.1984 38.4113 62.2022 43.6791 62.1984 44.1857C62.1184 58.5188 62.0613 68.045 61.4176 82.3324C58.8427 83.037 55.8908 83.3798 53.3578 82.359C53.2169 82.2181 52.9883 79.3842 52.9655 78.8319C52.6417 71.8311 53.0798 64.4912 52.9845 57.4408C52.8779 49.7277 52.4627 42.0146 52.1923 34.309C52.177 33.8253 52.1161 31.2733 52.2227 31.1057C52.257 31.0486 53.0112 30.8162 53.3692 30.3896C54.4091 29.1517 54.4053 25.9636 54.1501 24.4096L56.7744 24.2382L57.0068 24.4019C57.1363 24.6 57.0144 25.0304 57.1363 25.1637H57.1287Z",
    fill: "#AE2100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9844 27.1557L42.1824 23.6248L45.6257 24.2075C45.4658 24.7713 45.6524 24.9807 45.8886 25.4645C44.9706 26.7329 43.5499 27.3271 41.9844 27.1595V27.1557Z",
    fill: "#AE2100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7946 23.6248V26.6643C61.7946 26.7252 62.065 26.9424 61.9889 27.1518C60.8043 27.289 59.5092 26.9347 58.6484 26.0815C57.7876 25.2283 58.5265 25.0531 58.2637 24.0171L61.7946 23.6248Z",
    fill: "#AE2100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7923 24.0172L47.0845 23.8229L47.2597 21.9756L51.6095 22.1432L51.7923 24.0172Z",
    fill: "#AE2100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6753 21.8802L56.8924 23.8228L52.1846 24.0171V22.0555L56.6753 21.8802Z",
    fill: "#AE2100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7539 24.4095V28.428C53.7539 28.9232 52.9578 30.7857 52.1846 30.4886V24.7028L52.5083 24.44L53.7539 24.4095Z",
    fill: "#AE2100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7949 21.2709C61.7301 21.7356 61.9777 22.8821 61.6082 23.1411L58.2792 23.6058L58.0659 21.6594L61.7949 21.2671V21.2709Z",
    fill: "#AE2100"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7135 23.6248L42.3693 23.1411L42.1826 21.2709L45.7211 21.7508C46.1782 22.0479 45.5726 23.1144 45.7097 23.6248H45.7135Z",
    fill: "#AE2100"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8714 24.8018C57.3114 24.8932 57.5438 24.6837 57.4524 24.3485C57.2848 23.7353 57.2124 22.8973 57.1819 22.2536C57.1667 21.9184 56.9382 21.7546 57.38 21.4728C57.7457 21.4804 57.8371 24.3371 57.8675 24.8018H57.8714Z",
    fill: "#AE2100"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4942 24.8018C45.8619 25.0037 46.079 23.7163 46.1057 23.3354C46.1362 22.8555 46.239 21.7051 46.6885 21.469L46.4942 24.8018Z",
    fill: "#AE2100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotwear10);
export default __webpack_public_path__ + "static/media/notwear10.e77f24d2a526e6312175009f0fe42e62.svg";
export { ForwardRef as ReactComponent };